var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1984_16734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 34.2716,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1984_16734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V8H5V20ZM12 18C10.6333 18 9.4125 17.6292 8.3375 16.8875C7.2625 16.1458 6.48333 15.1833 6 14C6.48333 12.8167 7.2625 11.8542 8.3375 11.1125C9.4125 10.3708 10.6333 10 12 10C13.3667 10 14.5875 10.3708 15.6625 11.1125C16.7375 11.8542 17.5167 12.8167 18 14C17.5167 15.1833 16.7375 16.1458 15.6625 16.8875C14.5875 17.6292 13.3667 18 12 18ZM12 16.5C12.9333 16.5 13.7833 16.2792 14.55 15.8375C15.3167 15.3958 15.9167 14.7833 16.35 14C15.9167 13.2167 15.3167 12.6042 14.55 12.1625C13.7833 11.7208 12.9333 11.5 12 11.5C11.0667 11.5 10.2167 11.7208 9.45 12.1625C8.68333 12.6042 8.08333 13.2167 7.65 14C8.08333 14.7833 8.68333 15.3958 9.45 15.8375C10.2167 16.2792 11.0667 16.5 12 16.5ZM12 15.5C12.4167 15.5 12.7708 15.3542 13.0625 15.0625C13.3542 14.7708 13.5 14.4167 13.5 14C13.5 13.5833 13.3542 13.2292 13.0625 12.9375C12.7708 12.6458 12.4167 12.5 12 12.5C11.5833 12.5 11.2292 12.6458 10.9375 12.9375C10.6458 13.2292 10.5 13.5833 10.5 14C10.5 14.4167 10.6458 14.7708 10.9375 15.0625C11.2292 15.3542 11.5833 15.5 12 15.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.8d4790c678b3f05a8ae648ba1be3361f.svg";
export { ForwardRef as ReactComponent };